/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_PublishedInputs */

const en_directory_hubs_signals_published = /** @type {(inputs: Directory_Hubs_Signals_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published products`)
};

const zh_directory_hubs_signals_published = /** @type {(inputs: Directory_Hubs_Signals_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发布产品`)
};

/**
* | output |
* | --- |
* | "Published products" |
*
* @param {Directory_Hubs_Signals_PublishedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_published = /** @type {((inputs?: Directory_Hubs_Signals_PublishedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_PublishedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_published(inputs)
	return zh_directory_hubs_signals_published(inputs)
});
export { directory_hubs_signals_published as "directory.hubs.signals.published" }